import Vimeo from '@u-wave/react-vimeo'
import React, { useEffect, useState } from 'react'
import { FadeLoader } from 'react-spinners'
import Button from '../../../../components/button'
import { Link, useNavigate } from 'react-router-dom'
import TickMark from '../../../../components/tickmark'
import { saveStepsProgress } from '../../../../services/medium'

export default function StepFive({ NextStep ,innerWidthHandler }) {

    const navigate = useNavigate()

    const [showLoader, setShowLoader] = useState(true);
    const [verificationStatus, setVerificationStatus] = useState(0);
    const [showNext, setShowNext] = useState(false);

    const openAppointMent = () => {
        window.open("/integration", "_blank", "noreferrer")
    }
    useEffect(() => {
        setTimeout(() => {
            setVerificationStatus(1);
            setShowLoader(false);
        }, 7000)
    })

    const savestep = () => {
        let body = {
            step_number: 5
        }
        saveStepsProgress(body).then((data) => {
            if (data.data.status) {
                localStorage.setItem('step', 5)
                NextStep()
            }
        }).catch(() => {

        })
    }
    const createSchedule = () => {
        setShowNext(true);
        window.open("/availability?from=onboarding&time=1", "_blank");
        // navigate('/availability?from="onboarding',"")
    }
    return (
        <div className="onboarding-step-content">
            <div className='onboarding-step-header text-left'>

                <span className="onboarding-step-badge">Step 5</span>
                <div>
                    <h3 className='font-size-40'> Make a Schedule</h3>
                    <ol className='font-size-18 line-height-24px'>
                        <li>Watch the video below.</li>
                        <li>Create a Schedule. (optional)
                            <br />
                            
                            (Will open in a new tab. Come back here once complete.)
                        </li>

                        <li>Check Preview of Schedule.</li>
                    </ol>
                </div>
                {/* <p className='font-size-18 line-height-24px'>The Create a Schedule screen will open in a new tab. To continue the Onboarding process come back to this tab.</p> */}


            </div>
            <div className="onboarding-media-card">
                <div className="onboarding-media-header">
                    <h5>Watch walkthrough</h5>
                </div>
                <div className="onboarding-media-body">
                    <div className="onboarding-video-wrap ratio ratio-16x9">
                        <Vimeo
                            muted={true}
                            autoplay={false}
                  
                            // className="popover-video"
                            width={innerWidthHandler()}
                            height={330}
                            video={"https://vimeo.com/922236305/45a8a7bc1e"}
                        />
                    </div>
                </div>
            </div>
            <div className='onboarding-actions'>

                {!showNext ? <Button
                    className={"action-button margin-unset"}
                    status={0}
                    onClick={() => createSchedule()}
                    title="Create a Schedule" />
                    :
                    <Button
                        className={"action-button margin-unset"}
                        status={0}
                        onClick={() => savestep()}
                        title="Next" />}
                        

                <div>
                    <Button
                        className={"action-button margin-unset skip-pbtn "}
                        status={0}
                        onClick={() => savestep()}
                        title="Skip for Now" />
                </div>


            </div>
          <p className='onboarding-step-note mt-0'>Note: Create a schedule and then come back to this tab.</p> 

        </div>
    )
}
